import React, { useEffect, useState } from 'react';
import Pagination from '../../../components/pagination';
import {
  closingScheduleChangeNotifStatus,
  deleteClosingSchedule,
  searchClosingSchedule
} from '../../../api/sportaloka-client';
import FilterModal from './FilterModal';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

function ClosingScheduleTable({ onFilterLengthChanged }) {
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10,
    sort_field: 'updated_at',
    sort_value: 'desc',
    name: '',
    date: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const handlePageChange = (page) => {
    setPaginationOptions({ ...paginationOptions, page });
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: 'Apakah anda yakin?',
      text: 'Aksi ini tidak dapat dikembalikan',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Tetap lanjutkan!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          setData([]);
          await deleteClosingSchedule(id);
          await getData();
          Swal.fire({
            title: 'Berhasil!',
            text: `Jadwal tutup berhasil dihapus`,
            icon: 'success',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: `Periksa koneksi internet anda`,
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        }
      }
    });
  };

  const handleChangeNotification = async (id) => {
    Swal.fire({
      title: 'Apakah anda yakin?',
      text: 'Aksi ini tidak dapat dikembalikan',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Tetap lanjutkan!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          setData([]);
          await closingScheduleChangeNotifStatus(id);
          await getData();
          Swal.fire({
            title: 'Berhasil!',
            text: `Jadwal tutup berhasil dihapus`,
            icon: 'success',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: `Periksa koneksi internet anda`,
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        }
      }
    });
  };

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        name: paginationOptions.name,
        ...(paginationOptions.date && { date: paginationOptions.date })
      }).toString();
      const response = await searchClosingSchedule(query);
      const responseData = response.data.data.data;
      setData(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const handleFilter = (name, date) => {
    const nameLength = name ? 1 : 0;
    const dateLength = date ? 1 : 0;
    setPaginationOptions({ ...paginationOptions, name, date });
    onFilterLengthChanged(nameLength + dateLength);
  };

  return (
    <div className="mb-20">
      <FilterModal onFilter={handleFilter} />
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th style={{ width: '25%' }}>Judul</th>
            <th style={{ width: '15%' }}>Notification</th>
            <th style={{ width: '15%' }}>Mulai</th>
            <th style={{ width: '15%' }}>Selesai</th>
            <th style={{ width: '15%' }}>Dibuat</th>
            <th style={{ width: '15%' }}>Update Terakhir</th>
            <th className="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="6">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center" colSpan="6">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="6">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td>{row.name}</td>
              <td>
                {row.notification ? (
                  <div
                    className={`rounded-100 py-4 d-inline px-10 text-center col-12 text-14 fw-600 bg-blue-2 text-blue-1`}>
                    <i className="fa fa-check"></i>
                  </div>
                ) : (
                  <div
                    className={`rounded-100 py-4 d-inline px-10 text-center col-12 text-14 fw-600 bg-red-3 text-red-1`}>
                    <i className="fa fa-close"></i>
                  </div>
                )}
              </td>
              <td className="text-left">{format(new Date(row.start_at), 'dd/MM/yyyy')}</td>
              <td className="text-left">{format(new Date(row.end_at), 'dd/MM/yyyy')}</td>
              <td className="text-left">{format(new Date(row.created_at), 'dd/MM/yyyy')}</td>
              <td className="text-left">{format(new Date(row.updated_at), 'dd/MM/yyyy')}</td>
              <td className="text-center pe-0">
                <div className="dropdown js-dropdown js-actions-1-active">
                  <div
                    className="dropdown__button d-flex items-center rounded-4 text-blue-1 bg-blue-1-05 text-14 px-15 py-5"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="true"
                    aria-expanded="false"
                    data-bs-offset="0,10">
                    <span className="js-dropdown-title">
                      <i className="fa fa-ellipsis-v"></i>
                    </span>
                  </div>
                  <div
                    className="toggle-element -dropdown-2 js-click-dropdown dropdown-menu"
                    style={{ minWidth: 200 }}>
                    <div className="text-14 fw-500 js-dropdown-list">
                      <div>
                        <Link
                          to={`/closing-schedule/detail/${row.id}`}
                          className={`d-block js-dropdown-link d-flex align-items-center`}>
                          <i className="fa fa-eye text-16 text-info mr-10"></i>
                          <span>Detail</span>
                        </Link>
                      </div>
                      <div>
                        <button
                          onClick={() => handleDelete(row.id)}
                          className={`d-block js-dropdown-link d-flex align-items-center`}>
                          <i className="fa fa-trash text-16 text-danger mr-10"></i>
                          <span>Delete</span>
                        </button>
                      </div>
                      <div>
                        <button
                          onClick={() => handleChangeNotification(row.id)}
                          className={`d-block js-dropdown-link d-flex align-items-center`}>
                          <i className="fa fa-bell text-14 text-blue-1 mr-10"></i>
                          <span>Aktifkan Notifikasi</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        currentPage={paginationOptions.page}
        totalRows={totalRows}
        rowsPerPage={paginationOptions.limit}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default ClosingScheduleTable;
